import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import { BusinessHoursProvider } from "./context/businessHoursContext";

export default function Main() {
  return (
    <React.Fragment>
      <BusinessHoursProvider>
        <Header />

        {/*Render views as set in App.tsx */}
        <Outlet />
        <Footer />
      </BusinessHoursProvider>
    </React.Fragment>
  );
}
